module.exports = __webpack_public_path__ + "img/56.77359fb6.jpg";